import type {
  HeaderImage,
  ResourceGroup,
  ResourceGroupContent,
  TextContent,
} from '@/data/learning-path/interfaces';

export enum ActionType {
  AddBlock = 'ADD_BLOCK',
  UpdateBlock = 'UPDATE_BLOCK',
  RemoveBlock = 'REMOVE_BLOCK',
  ReorderBlocks = 'REORDER_BLOCKS',
}

export type ContentBlock = TextContent | ResourceGroupContent;

type AddBlock = {
  type: ActionType.AddBlock;
  payload: Omit<ContentBlock, 'id' | 'position'>;
};

type UpdateBlock = {
  type: ActionType.UpdateBlock;
  payload: { id: string; data: Partial<ContentBlock> };
};

type RemoveBlock = {
  type: ActionType.RemoveBlock;
  payload: { id: string };
};

type ReorderBlocks = {
  type: ActionType.ReorderBlocks;
  payload: ContentBlock[];
};

export type Action = AddBlock | UpdateBlock | RemoveBlock | ReorderBlocks;

export interface ManagePathContextProps {
  contents: ContentBlock[];
  headerImage: HeaderImage;
  pathId: string;
  title: string;
  description: string;
  isGlobal: boolean;
  hasContentChanged: boolean;
  setHasContentChanged: (hasChanged: boolean) => void;
  hasImageChanged: boolean;
  isDraftVersion: boolean;
  setIsDraftVersion: (is_draft: boolean) => void;
  alreadyPublished: boolean;
  setAlreadyPublished: (published: boolean) => void;
  setTitle: (title: string) => void;
  setDescription: (desc: string) => void;
  addTextBlock: () => void;
  addResourcesBlock: () => void;
  addResourceToBlock: (blockId: string, resource: ResourceGroup) => void;
  removeResourceFromBlock: (blockId: string, resourceId: string) => void;
  updateBlock: (id: string, data: Partial<ContentBlock>) => void;
  removeBlock: (id: string) => void;
  setHeaderImage: (image: HeaderImage | null) => void;
  updateResourceInBlock: (
    blockId: string,
    updatedResource: ResourceGroup
  ) => void;
  reorderBlocks: (blocks: ContentBlock[]) => void;
}
